export const BUTTON_TYPE = {
  SUBMIT: 'submit'
};
